import { render } from "./SeaFrontEditing.vue?vue&type=template&id=49720259&ts=true"
import script from "./SeaFrontEditing.vue?vue&type=script&lang=ts"
export * from "./SeaFrontEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__